<template>
  <div class="currency-activation-description">
    <ul class="description__list">
      <li
          v-for="(description, idx) in content"
          :key="description.id"
          :class="['description__item', { 'active': description.id === activeDesc }]"
          @mouseover="setActiveDescription(description)"
      >
        <div class="description__item-count">
          <p>{{ idx + 1 }}</p>
        </div>
        <div class="description__item-text">
          <p>{{ $t(description.text) }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    activeDesc: {
      type: Number,
      default: 1,
    },

    content: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    setActiveDescription(description) {
      this.$emit('activeDescription', description);
    },
  },
}
</script>